import './index.scss'

import { enableNavbarScroll, setActiveNav, setCopyright } from '../lib/app/js/app'

enableNavbarScroll()
setActiveNav()
setCopyright()



// WEBPACK FOOTER //
// ./src/en/product/index.js